import type { FloorPlanFolderRecord } from "../../utils/types";

// numeric: "Level 2" sorts before "Level 10".
export const sortFolderRecordsByName = (
  folderRecords: FloorPlanFolderRecord[],
): FloorPlanFolderRecord[] =>
  [...folderRecords].sort((firstFolder, secondFolder) =>
    firstFolder.name.localeCompare(secondFolder.name, undefined, {
      numeric: true,
    }),
  );
